/**
 * @file Resolves the display name of a timezone code.
 */

import keyBy from "lodash.keyby";
import timezones from "timezones-list";
import type { TimeZone } from "timezones-list";

const TIMEZONES_MAP: Record<string, TimeZone> = keyBy(timezones, "tzCode");

/**
 * Resolves the display name for the given timezone code, or an empty string when it is not found.
 */
const getFormattedTimezone = (tzCode?: string): string => {
  if (!tzCode) {
    return "";
  }

  const timezone = TIMEZONES_MAP[tzCode];

  if (!timezone) {
    console.error(`Not found timezone for ${tzCode}`);

    return "";
  }

  const { name } = timezone;

  return name;
};

export default getFormattedTimezone;
